import { loadFoundAFittieEnterAnimation, loadFoundAFittieRemovalAnimation } from "./matchCelebrationLottie";
import type { LottieAnimationData } from "./matchCelebrationTypes";

let modulePreload: Promise<typeof import("./MatchCelebration")> | null = null;
let enterAnimationPromise: Promise<LottieAnimationData> | null = null;
let removalAnimationPromise: Promise<LottieAnimationData> | null = null;
let cachedEnterAnimation: LottieAnimationData | null = null;
let cachedRemovalAnimation: LottieAnimationData | null = null;

export function preloadMatchCelebrationAssets(): void {
  if (typeof window === "undefined") {
    return;
  }

  modulePreload ??= import("./MatchCelebration");
  enterAnimationPromise ??= loadFoundAFittieEnterAnimation().then((data) => {
    cachedEnterAnimation = data;
    return data;
  });
  removalAnimationPromise ??= loadFoundAFittieRemovalAnimation().then((data) => {
    cachedRemovalAnimation = data;
    return data;
  });
}

export function preloadMatchCelebrationWhenIdle(): void {
  if (typeof window === "undefined") {
    return;
  }

  const run = () => preloadMatchCelebrationAssets();
  const scheduleIdle = window.requestIdleCallback;

  if (typeof scheduleIdle === "function") {
    scheduleIdle(run, { timeout: 2500 });
    return;
  }

  setTimeout(run, 400);
}

export function preloadProfilePhotosForCelebration(...urls: Array<string | undefined>): void {
  if (typeof window === "undefined") {
    return;
  }

  for (const url of urls) {
    if (!url?.trim()) {
      continue;
    }
    const image = new Image();
    image.decoding = "async";
    image.src = url;
  }
}

export function loadMatchCelebrationModule(): Promise<typeof import("./MatchCelebration")> {
  preloadMatchCelebrationAssets();
  modulePreload ??= import("./MatchCelebration");
  return modulePreload;
}

export function getCachedFoundAFittieEnterAnimation(): LottieAnimationData | null {
  return cachedEnterAnimation;
}

export function getCachedFoundAFittieRemovalAnimation(): LottieAnimationData | null {
  return cachedRemovalAnimation;
}

export async function getFoundAFittieEnterAnimation(): Promise<LottieAnimationData> {
  if (cachedEnterAnimation) {
    return cachedEnterAnimation;
  }
  preloadMatchCelebrationAssets();
  if (!enterAnimationPromise) {
    throw new Error("FoundAFittie enter animation preload was not started");
  }
  return enterAnimationPromise;
}

export async function getFoundAFittieRemovalAnimation(): Promise<LottieAnimationData> {
  if (cachedRemovalAnimation) {
    return cachedRemovalAnimation;
  }
  preloadMatchCelebrationAssets();
  if (!removalAnimationPromise) {
    throw new Error("FoundAFittie removal animation preload was not started");
  }
  return removalAnimationPromise;
}
